import {contactUsForm} from '../components/forms'

const contact = _ => {
    
    contactUsForm()
}

export default contact